/**
 * @generated SignedSource<<8f9591297349abe4f2a0069e3749cf83>>
 * @relayHash 721e010c554f96a80cc0e7b4c8b01b35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bc1540bd4922e74c0118dda4a1a405f059de90be1142b8d8648f83bad666aed

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionSortField = "DESCRIPTION" | "NAME" | "RELEASE_DATE" | "SEQUENCE" | "START_DATE" | "%future added value";
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionSortInput = {
  order: SortDirection;
  sortByField: JiraVersionSortField;
};
export type projectVersion_PaginationQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  filter?: ReadonlyArray<JiraVersionStatus | null | undefined> | null | undefined;
  first?: number | null | undefined;
  isManageVersionsPermissionEnabled?: boolean | null | undefined;
  projectKey: string;
  searchString?: string | null | undefined;
  sortBy?: JiraVersionSortInput | null | undefined;
};
export type projectVersion_PaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"table_projectVersions">;
};
export type projectVersion_PaginationQuery = {
  response: projectVersion_PaginationQuery$data;
  variables: projectVersion_PaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": [
      "UNRELEASED"
    ],
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isManageVersionsPermissionEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "searchString"
  },
  {
    "defaultValue": {
      "order": "DESC",
      "sortByField": "SEQUENCE"
    },
    "kind": "LocalArgument",
    "name": "sortBy"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "searchString",
  "variableName": "searchString"
},
v5 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v9 = [
  (v8/*: any*/)
],
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": "DONE"
  }
],
v11 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "projectVersion_PaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "isManageVersionsPermissionEnabled",
            "variableName": "isManageVersionsPermissionEnabled"
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "table_projectVersions"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "projectVersion_PaginationQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              (v6/*: any*/),
              {
                "condition": "isManageVersionsPermissionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "canEditVersions",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "MANAGE_VERSIONS"
                      }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canPerform"
                      }
                    ],
                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                  }
                ]
              },
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "releaseDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "overdue"
                          },
                          {
                            "alias": "allIssues",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "ALL"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": "issues(filter:\"ALL\")"
                          },
                          {
                            "alias": "doneIssues",
                            "args": (v10/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": "issues(filter:\"DONE\")"
                          },
                          {
                            "alias": "done",
                            "args": (v10/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": "issues(filter:\"DONE\")"
                          },
                          {
                            "alias": "inProgress",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "IN_PROGRESS"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                          },
                          {
                            "alias": "toDo",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "TODO"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": "issues(filter:\"TODO\")"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "versionId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  (v11/*: any*/)
                ]
              },
              {
                "args": (v7/*: any*/),
                "filters": [
                  "filter",
                  "searchString",
                  "sortBy"
                ],
                "handle": "connection",
                "key": "uiProject__versions",
                "kind": "LinkedHandle",
                "name": "versions"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8bc1540bd4922e74c0118dda4a1a405f059de90be1142b8d8648f83bad666aed",
    "metadata": {},
    "name": "projectVersion_PaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cf9237bc92fce2676b1bfc7b6dbe5172";

export default node;
